import { render, staticRenderFns } from "./CeremoniesPage.vue?vue&type=template&id=0c9d9b26"
import script from "./CeremoniesPage.vue?vue&type=script&setup=true&lang=js"
export * from "./CeremoniesPage.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports